import React, { useState } from 'react';
import orangeLogo from '../assets/orangelog.png';

const PS_NAVY  = '#13273F';
const PS_RED   = '#F41238';
const USD      = '0.12';

function Logo({ h = 22 }) {
  return <img src={orangeLogo} alt="PubSilo" style={{ height: h, display: 'block', flexShrink: 0 }} />;
}

// Fake blurred article snippet shown above each option
function PaywallSnippet() {
  return (
    <div style={{ position: 'relative', marginBottom: '0.75rem', fontFamily: 'Georgia, serif' }}>
      <p style={{ fontSize: '0.95rem', lineHeight: 1.7, color: '#222', margin: 0 }}>
        The commission's draft findings, released Thursday after a six-month review, paint a stark picture of
        the region's water infrastructure — aging pipes, underfunded maintenance schedules, and a projected
        shortfall of nearly $400 million over the next decade. Officials warn that without intervention…
      </p>
      <div style={{
        position: 'absolute', bottom: 0, left: 0, right: 0, height: '60px',
        background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.97) 100%)',
      }} />
    </div>
  );
}

function Option({ num, label, best, children }) {
  return (
    <div style={{
      background: '#fff', border: '1px solid #e0e0e0', borderRadius: '10px',
      padding: '1.5rem', boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    }}>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.6rem', marginBottom: '0.35rem' }}>
        <span style={{ fontSize: '0.72rem', fontWeight: '700', color: '#fff', background: PS_NAVY, borderRadius: '4px', padding: '0.1rem 0.45rem', letterSpacing: '0.04em' }}>
          OPTION {num}
        </span>
        <span style={{ fontSize: '0.9rem', fontWeight: '700', color: '#222' }}>{label}</span>
      </div>
      {best && (
        <div style={{ fontSize: '0.75rem', color: '#666', marginBottom: '1rem', fontStyle: 'italic' }}>
          Best for: {best}
        </div>
      )}
      <PaywallSnippet />
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {children}
      </div>
    </div>
  );
}

// ── SET 1: Original 10 (cleaned — no subscription language, $ only) ───────────

function Opt1() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '0.55rem',
        padding: '0.65rem 1.4rem',
        backgroundColor: hov ? '#1e3a5f' : PS_NAVY,
        color: '#fff', borderRadius: '7px',
        fontFamily: 'Arial, sans-serif', fontSize: '0.92rem', fontWeight: '600',
        textDecoration: 'none', transition: 'background 0.15s',
        boxShadow: hov ? '0 4px 14px rgba(19,39,63,0.35)' : '0 2px 6px rgba(19,39,63,0.25)',
      }}>
      🔓 Read Full Article
      <span style={{ fontSize: '0.8rem', opacity: 0.8, fontWeight: '400' }}>· ${USD}</span>
    </a>
  );
}

function Opt2() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 0,
        borderRadius: '6px', overflow: 'hidden',
        textDecoration: 'none', fontFamily: 'Arial, sans-serif', fontSize: '0.82rem',
        boxShadow: hov ? '0 3px 10px rgba(0,0,0,0.2)' : '0 1px 4px rgba(0,0,0,0.12)',
        transition: 'box-shadow 0.15s',
      }}>
      <span style={{ background: PS_RED, color: '#fff', padding: '0.45rem 0.75rem', fontWeight: '700', fontSize: '0.75rem', letterSpacing: '0.05em' }}>
        PUBSILO
      </span>
      <span style={{ background: PS_NAVY, color: '#fff', padding: '0.45rem 0.9rem', fontWeight: '600' }}>
        Unlock Article
      </span>
      <span style={{ background: '#e8edf2', color: PS_NAVY, padding: '0.45rem 0.75rem', fontWeight: '700' }}>
        ${USD}
      </span>
    </a>
  );
}

function Opt3() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{
      border: `1.5px solid ${PS_NAVY}`, borderRadius: '10px', overflow: 'hidden',
      width: '280px', fontFamily: 'Arial, sans-serif',
      boxShadow: hov ? '0 6px 20px rgba(19,39,63,0.2)' : '0 2px 8px rgba(0,0,0,0.1)',
      transition: 'box-shadow 0.15s',
    }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{ background: PS_NAVY, padding: '0.5rem 0.9rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span style={{ color: PS_RED, fontWeight: '900', fontSize: '0.85rem', letterSpacing: '0.04em' }}>PubSilo</span>
        <span style={{ color: '#aabdd1', fontSize: '0.7rem' }}>Instant access</span>
      </div>
      <div style={{ padding: '0.75rem 0.9rem', background: '#f7f9fb' }}>
        <div style={{ fontSize: '0.82rem', color: '#555', marginBottom: '0.5rem' }}>
          🔒 This article is paywalled. Access it on PubSilo for:
        </div>
        <div style={{ fontSize: '1.3rem', fontWeight: '800', color: PS_NAVY, marginBottom: '0.55rem' }}>
          ${USD}
        </div>
        <a href="#" style={{
          display: 'block', textAlign: 'center', background: PS_RED, color: '#fff',
          padding: '0.5rem', borderRadius: '6px', fontWeight: '700', fontSize: '0.85rem',
          textDecoration: 'none',
        }}>
          Read Now →
        </a>
      </div>
    </div>
  );
}

function Opt4() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
        padding: '0.55rem 1.5rem',
        background: hov ? PS_RED : '#fff',
        color: hov ? '#fff' : PS_RED,
        border: `2px solid ${PS_RED}`,
        borderRadius: '999px',
        fontFamily: 'Arial, sans-serif', fontSize: '0.88rem', fontWeight: '700',
        textDecoration: 'none', transition: 'all 0.15s',
      }}>
      Read on PubSilo · ${USD}
    </a>
  );
}

function Opt5() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        width: '100%', maxWidth: '480px',
        background: hov ? '#0e1e30' : PS_NAVY,
        color: '#fff', borderRadius: '8px',
        padding: '0.65rem 1.1rem',
        fontFamily: 'Arial, sans-serif', fontSize: '0.85rem',
        textDecoration: 'none', transition: 'background 0.15s',
        boxSizing: 'border-box',
      }}>
      <span style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
        <span style={{ color: PS_RED, fontWeight: '900', fontSize: '0.9rem' }}>PubSilo</span>
        <span style={{ opacity: 0.75 }}>·</span>
        <span>Pay once, read immediately</span>
      </span>
      <span style={{
        background: PS_RED, borderRadius: '5px', padding: '0.25rem 0.65rem',
        fontWeight: '700', fontSize: '0.8rem', whiteSpace: 'nowrap',
      }}>
        ${USD}
      </span>
    </a>
  );
}

function Opt6() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '0.6rem',
        padding: '0.55rem 1.2rem',
        background: 'transparent',
        color: hov ? PS_NAVY : '#444',
        border: `1.5px solid ${hov ? PS_NAVY : '#bbb'}`,
        borderRadius: '6px',
        fontFamily: 'Arial, sans-serif', fontSize: '0.85rem', fontWeight: '600',
        textDecoration: 'none', transition: 'all 0.15s',
      }}>
      🔓 Continue reading on <strong style={{ color: PS_RED }}>PubSilo</strong>
      <span style={{ color: '#888', fontWeight: '400', fontSize: '0.8rem' }}>${USD}</span>
    </a>
  );
}

function Opt7() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{
      display: 'inline-flex', borderRadius: '7px', overflow: 'hidden',
      border: `1.5px solid ${PS_NAVY}`, fontFamily: 'Arial, sans-serif',
      boxShadow: hov ? '0 4px 14px rgba(0,0,0,0.18)' : '0 1px 4px rgba(0,0,0,0.1)',
      transition: 'box-shadow 0.15s',
    }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{ padding: '0.55rem 1rem', background: '#f0f4f8', color: PS_NAVY, fontSize: '0.82rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.4rem' }}>
        <span style={{ color: PS_RED, fontWeight: '900' }}>PubSilo</span> — full article
      </div>
      <a href="#" style={{
        padding: '0.55rem 1rem', background: PS_NAVY, color: '#fff',
        fontSize: '0.82rem', fontWeight: '700', textDecoration: 'none',
        display: 'flex', alignItems: 'center', gap: '0.4rem',
      }}>
        Unlock · ${USD}
      </a>
    </div>
  );
}

function Opt8() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', flexDirection: 'column', alignItems: 'center',
        padding: '0.65rem 1.25rem',
        background: hov ? '#f7f9fb' : '#fff',
        border: `1px solid ${hov ? PS_NAVY : '#ddd'}`,
        borderRadius: '8px', textDecoration: 'none',
        transition: 'all 0.15s', fontFamily: 'Arial, sans-serif',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
      }}>
      <span style={{ fontSize: '0.7rem', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: '0.15rem' }}>Read on</span>
      <span style={{ fontWeight: '900', fontSize: '1.05rem', color: PS_NAVY, letterSpacing: '-0.01em' }}>
        Pub<span style={{ color: PS_RED }}>Silo</span>
      </span>
      <span style={{ fontSize: '0.72rem', color: '#666', marginTop: '0.15rem' }}>🔓 ${USD}</span>
    </a>
  );
}

function Opt9() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '0.65rem',
        padding: '0.7rem 1.6rem',
        background: hov
          ? 'linear-gradient(135deg, #1e3a5f 0%, #c0001f 100%)'
          : 'linear-gradient(135deg, #13273F 0%, #F41238 100%)',
        color: '#fff', borderRadius: '8px',
        fontFamily: 'Arial, sans-serif', fontSize: '0.9rem', fontWeight: '700',
        textDecoration: 'none', transition: 'all 0.2s',
        boxShadow: hov ? '0 6px 20px rgba(244,18,56,0.4)' : '0 3px 10px rgba(244,18,56,0.25)',
      }}>
      ⚡ Instant Access · <span style={{ fontWeight: '400', opacity: 0.88 }}>${USD}</span>
    </a>
  );
}

function Opt10() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{ fontFamily: 'Georgia, serif', fontSize: '0.95rem', lineHeight: 1.75, color: '#222', maxWidth: '460px', textAlign: 'left' }}>
      <em style={{ color: '#555' }}>
        This article continues on PubSilo.{' '}
        <a href="#"
          onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
          style={{ color: hov ? PS_RED : '#1a6fc7', fontWeight: '700', textDecoration: 'underline', transition: 'color 0.15s' }}>
          Unlock the full piece for ${USD} →
        </a>
      </em>
    </div>
  );
}

// ── SET 2: New 10 — logo-forward, $ only ─────────────────────────────────────

// 11 — Logo badge (stacked, compact)
function Opt11() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem',
        padding: '0.8rem 1.4rem',
        background: hov ? '#f5f7fa' : '#fff',
        border: `1.5px solid ${hov ? PS_NAVY : '#dde3ea'}`,
        borderRadius: '10px', textDecoration: 'none',
        boxShadow: hov ? '0 4px 16px rgba(19,39,63,0.15)' : '0 1px 5px rgba(0,0,0,0.08)',
        transition: 'all 0.15s', fontFamily: 'Arial, sans-serif',
      }}>
      <Logo h={28} />
      <span style={{ fontSize: '1.1rem', fontWeight: '800', color: PS_NAVY }}>${USD}</span>
      <span style={{ fontSize: '0.72rem', color: '#888', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Read Full Article</span>
    </a>
  );
}

// 12 — Horizontal logo lockup
function Opt12() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 0,
        borderRadius: '8px', overflow: 'hidden', textDecoration: 'none',
        boxShadow: hov ? '0 4px 16px rgba(0,0,0,0.18)' : '0 2px 7px rgba(0,0,0,0.1)',
        transition: 'box-shadow 0.15s', fontFamily: 'Arial, sans-serif',
      }}>
      {/* Logo slab */}
      <div style={{ background: PS_NAVY, padding: '0.6rem 0.9rem', display: 'flex', alignItems: 'center' }}>
        <Logo h={20} />
      </div>
      {/* Middle */}
      <div style={{ background: '#f0f4f8', padding: '0.6rem 0.9rem', color: PS_NAVY, fontSize: '0.84rem', fontWeight: '600' }}>
        Read full article
      </div>
      {/* Price */}
      <div style={{ background: PS_RED, padding: '0.6rem 0.9rem', color: '#fff', fontWeight: '800', fontSize: '0.95rem' }}>
        ${USD}
      </div>
    </a>
  );
}

// 13 — Dark premium card with logo
function Opt13() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{
      background: PS_NAVY, borderRadius: '12px', padding: '1.1rem 1.25rem',
      width: '260px', fontFamily: 'Arial, sans-serif',
      boxShadow: hov ? '0 8px 28px rgba(19,39,63,0.5)' : '0 4px 16px rgba(19,39,63,0.35)',
      transition: 'box-shadow 0.2s',
    }}
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.85rem' }}>
        <Logo h={26} />
        <span style={{ fontSize: '0.68rem', color: '#7a9bb5', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Exclusive</span>
      </div>
      <div style={{ fontSize: '0.82rem', color: '#8eb3cc', marginBottom: '0.4rem' }}>Full article access</div>
      <div style={{ fontSize: '2rem', fontWeight: '900', color: '#fff', lineHeight: 1, marginBottom: '0.9rem' }}>
        ${USD}
      </div>
      <a href="#" style={{
        display: 'block', textAlign: 'center', background: PS_RED, color: '#fff',
        padding: '0.55rem', borderRadius: '7px', fontWeight: '700', fontSize: '0.88rem',
        textDecoration: 'none', letterSpacing: '0.02em',
      }}>
        Unlock Now →
      </a>
    </div>
  );
}

// 14 — Newspaper masthead style
function Opt14() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', flexDirection: 'column', alignItems: 'center', gap: '0.3rem',
        padding: '0.85rem 1.5rem',
        background: '#fff', border: `2px solid ${PS_NAVY}`,
        borderRadius: '4px', textDecoration: 'none',
        boxShadow: hov ? '4px 4px 0 ' + PS_NAVY : '2px 2px 0 ' + PS_NAVY,
        transition: 'box-shadow 0.12s', fontFamily: 'Georgia, serif',
      }}>
      <div style={{ fontSize: '0.65rem', color: '#888', letterSpacing: '0.12em', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>
        Available on
      </div>
      <Logo h={22} />
      <div style={{ borderTop: `1px solid ${PS_NAVY}`, borderBottom: `1px solid ${PS_NAVY}`, padding: '0.2rem 1rem', margin: '0.15rem 0' }}>
        <span style={{ fontSize: '1.15rem', fontWeight: '700', color: PS_NAVY, letterSpacing: '0.03em' }}>${USD}</span>
      </div>
      <div style={{ fontSize: '0.68rem', color: '#666', fontFamily: 'Arial, sans-serif', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
        Full Access
      </div>
    </a>
  );
}

// 15 — Pill with logo icon
function Opt15() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 0,
        borderRadius: '999px', overflow: 'hidden', textDecoration: 'none',
        boxShadow: hov ? '0 4px 16px rgba(19,39,63,0.3)' : '0 2px 8px rgba(0,0,0,0.12)',
        transition: 'box-shadow 0.15s', fontFamily: 'Arial, sans-serif',
      }}>
      <div style={{ background: PS_NAVY, padding: '0.5rem 0.8rem 0.5rem 1rem', display: 'flex', alignItems: 'center' }}>
        <Logo h={18} />
      </div>
      <div style={{ background: hov ? '#f0f4f8' : '#fff', padding: '0.5rem 0.5rem 0.5rem 0.7rem', color: PS_NAVY, fontSize: '0.84rem', fontWeight: '600' }}>
        Read for
      </div>
      <div style={{ background: hov ? PS_RED : '#e8edf2', padding: '0.5rem 1rem 0.5rem 0.5rem', color: hov ? '#fff' : PS_NAVY, fontWeight: '800', fontSize: '0.88rem', transition: 'all 0.15s' }}>
        ${USD}
      </div>
    </a>
  );
}

// 16 — Ticket / stub style
function Opt16() {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', borderRadius: '8px', overflow: 'hidden',
        fontFamily: 'Arial, sans-serif',
        boxShadow: hov ? '0 6px 20px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.12)',
        transition: 'box-shadow 0.15s',
      }}>
      {/* Left stub — logo on red */}
      <div style={{
        background: PS_RED, padding: '0.75rem 0.9rem', display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center', gap: '0.3rem',
        borderRight: '2px dashed rgba(255,255,255,0.4)',
      }}>
        <Logo h={20} />
        <span style={{ fontSize: '0.6rem', color: 'rgba(255,255,255,0.8)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Admit one</span>
      </div>
      {/* Right — price and action */}
      <a href="#" style={{
        background: '#fff', padding: '0.75rem 1.1rem', display: 'flex', flexDirection: 'column',
        justifyContent: 'center', gap: '0.15rem', textDecoration: 'none',
      }}>
        <span style={{ fontSize: '1.4rem', fontWeight: '900', color: PS_NAVY, lineHeight: 1 }}>${USD}</span>
        <span style={{ fontSize: '0.72rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Full article access →</span>
      </a>
    </div>
  );
}

// 17 — Mobile app-banner style
function Opt17() {
  const [hov, setHov] = useState(false);
  return (
    <div
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'flex', alignItems: 'center', gap: '0.75rem',
        width: '100%', maxWidth: '460px', boxSizing: 'border-box',
        background: hov ? '#f5f7fa' : '#fff',
        border: '1px solid #dde3ea', borderRadius: '10px',
        padding: '0.6rem 0.85rem',
        boxShadow: hov ? '0 4px 14px rgba(0,0,0,0.12)' : '0 1px 5px rgba(0,0,0,0.07)',
        transition: 'all 0.15s', fontFamily: 'Arial, sans-serif',
      }}>
      <div style={{ background: PS_NAVY, borderRadius: '8px', padding: '0.45rem', flexShrink: 0 }}>
        <Logo h={22} />
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: '700', fontSize: '0.84rem', color: PS_NAVY }}>Read on PubSilo</div>
        <div style={{ fontSize: '0.72rem', color: '#888' }}>Full article · ${USD}</div>
      </div>
      <a href="#" style={{
        background: PS_RED, color: '#fff', borderRadius: '6px',
        padding: '0.4rem 0.85rem', fontWeight: '700', fontSize: '0.8rem',
        textDecoration: 'none', whiteSpace: 'nowrap', flexShrink: 0,
      }}>
        Open
      </a>
    </div>
  );
}

// 18 — Glassmorphism card
function Opt18() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{ background: 'linear-gradient(135deg, #13273F 0%, #1a4a70 50%, #8b0000 100%)', borderRadius: '12px', padding: '3px' }}>
      <a href="#"
        onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
        style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.45rem',
          padding: '1rem 1.5rem',
          background: hov ? 'rgba(19,39,63,0.7)' : 'rgba(19,39,63,0.55)',
          backdropFilter: 'blur(12px)',
          borderRadius: '10px', textDecoration: 'none',
          transition: 'background 0.2s',
        }}>
        <Logo h={26} />
        <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.75rem', letterSpacing: '0.08em', textTransform: 'uppercase', fontFamily: 'Arial, sans-serif' }}>
          Full article access
        </div>
        <div style={{ color: '#fff', fontSize: '1.5rem', fontWeight: '900', fontFamily: 'Arial, sans-serif', lineHeight: 1 }}>
          ${USD}
        </div>
        <div style={{
          background: PS_RED, color: '#fff', borderRadius: '6px',
          padding: '0.35rem 1.2rem', fontWeight: '700', fontSize: '0.8rem', fontFamily: 'Arial, sans-serif',
        }}>
          Read Now
        </div>
      </a>
    </div>
  );
}

// 19 — Bold editorial price
function Opt19() {
  const [hov, setHov] = useState(false);
  return (
    <a href="#"
      onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
      style={{
        display: 'inline-flex', alignItems: 'center', gap: '1rem',
        padding: '0.75rem 1.25rem 0.75rem 0.9rem',
        background: '#fff', border: `1px solid ${hov ? PS_NAVY : '#ddd'}`,
        borderRadius: '8px', textDecoration: 'none',
        boxShadow: hov ? '0 4px 14px rgba(0,0,0,0.12)' : '0 1px 4px rgba(0,0,0,0.07)',
        transition: 'all 0.15s', fontFamily: 'Arial, sans-serif',
      }}>
      <div style={{ borderRight: '1px solid #e5e7eb', paddingRight: '1rem' }}>
        <Logo h={20} />
      </div>
      <div>
        <div style={{ fontSize: '0.68rem', color: '#999', textTransform: 'uppercase', letterSpacing: '0.08em', marginBottom: '0.1rem' }}>
          Full article
        </div>
        <div style={{ fontSize: '1.5rem', fontWeight: '900', color: PS_NAVY, lineHeight: 1 }}>
          ${USD} <span style={{ fontSize: '0.8rem', color: PS_RED, fontWeight: '700' }}>→</span>
        </div>
      </div>
    </a>
  );
}

// 20 — Branded unlock strip (full width, accent left border)
function Opt20() {
  const [hov, setHov] = useState(false);
  return (
    <div style={{ width: '100%', maxWidth: '460px' }}>
      <div
        onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)}
        style={{
          display: 'flex', alignItems: 'center', gap: '0.9rem',
          borderLeft: `4px solid ${PS_RED}`,
          background: hov ? '#f5f7fa' : '#fff',
          padding: '0.75rem 1rem',
          borderRadius: '0 8px 8px 0',
          boxShadow: hov ? '0 4px 16px rgba(0,0,0,0.12)' : '0 1px 5px rgba(0,0,0,0.07)',
          transition: 'all 0.15s', fontFamily: 'Arial, sans-serif',
        }}>
        <div style={{ background: PS_NAVY, borderRadius: '6px', padding: '0.4rem 0.5rem', flexShrink: 0 }}>
          <Logo h={18} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: '700', fontSize: '0.85rem', color: PS_NAVY }}>This article is available on PubSilo</div>
          <div style={{ fontSize: '0.75rem', color: '#888' }}>One-time access · ${USD}</div>
        </div>
        <a href="#" style={{
          background: PS_NAVY, color: '#fff', borderRadius: '6px',
          padding: '0.45rem 0.9rem', fontWeight: '700', fontSize: '0.82rem',
          textDecoration: 'none', flexShrink: 0,
        }}>
          Read →
        </a>
      </div>
    </div>
  );
}

// ── Page ─────────────────────────────────────────────────────────────────────

export default function TestLinks() {
  return (
    <div style={{ minHeight: '100vh', background: '#f2f4f7', fontFamily: 'Arial, sans-serif', padding: '2.5rem 1.25rem 4rem' }}>

      {/* Header */}
      <div style={{ maxWidth: '860px', margin: '0 auto 2rem' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.5rem' }}>
          <Logo h={28} />
          <span style={{ fontSize: '0.72rem', fontWeight: '700', color: '#888', textTransform: 'uppercase', letterSpacing: '0.07em' }}>
            Embedded Link Design Lab
          </span>
        </div>
        <h1 style={{ fontSize: '1.6rem', fontWeight: '800', color: '#1a1a1a', margin: '0 0 0.4rem' }}>
          Publisher Link Options
        </h1>
        <p style={{ color: '#666', fontSize: '0.9rem', margin: 0, lineHeight: 1.6 }}>
          20 designs for the "read on PubSilo" link embedded in a publisher's paywall area.
          Each shown in context with a blurred snippet above. Price shown: <strong>${USD}</strong>.
        </p>
      </div>

      {/* Set 1 */}
      <div style={{ maxWidth: '860px', margin: '0 auto 1rem' }}>
        <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.75rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.4rem' }}>
          Set 1 — Text-forward
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: '1.25rem' }}>
          <Option num={1}  label="Standard CTA Button"       best="blog-style sites, news publishers"><Opt1 /></Option>
          <Option num={2}  label="Three-Segment Badge"        best="compact, price-prominent placement"><Opt2 /></Option>
          <Option num={3}  label="Paywall Card"               best="sites with a dedicated paywall panel"><Opt3 /></Option>
          <Option num={4}  label="Pill / Outlined Button"     best="modern-design, light-themed sites"><Opt4 /></Option>
          <Option num={5}  label="Slim Full-Width Banner"     best="newspaper-style sites"><Opt5 /></Option>
          <Option num={6}  label="Ghost / Minimal Outlined"   best="design-conscious publishers"><Opt6 /></Option>
          <Option num={7}  label="Split Label + Action"       best="context left, CTA separated right"><Opt7 /></Option>
          <Option num={8}  label="Trust Badge"                best="sidebar or alongside share buttons"><Opt8 /></Option>
          <Option num={9}  label="Gradient Premium Button"    best="premium or investigative content"><Opt9 /></Option>
          <Option num={10} label="Inline Text Link"           best="zero visual interruption, body copy"><Opt10 /></Option>
        </div>
      </div>

      {/* Set 2 */}
      <div style={{ maxWidth: '860px', margin: '2rem auto 0' }}>
        <div style={{ fontSize: '0.72rem', fontWeight: '700', color: '#aaa', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '0.75rem', borderBottom: '1px solid #e0e0e0', paddingBottom: '0.4rem' }}>
          Set 2 — Logo-forward · dollar pricing only
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(380px, 1fr))', gap: '1.25rem' }}>
          <Option num={11} label="Logo Badge (stacked)"      best="any site — logo drives trust"><Opt11 /></Option>
          <Option num={12} label="Horizontal Logo Lockup"    best="clean, three-part split bar"><Opt12 /></Option>
          <Option num={13} label="Dark Premium Card"         best="high-value or exclusive content"><Opt13 /></Option>
          <Option num={14} label="Newspaper Masthead"        best="editorial, print-heritage publishers"><Opt14 /></Option>
          <Option num={15} label="Logo Pill"                 best="modern sites, tight on space"><Opt15 /></Option>
          <Option num={16} label="Ticket Stub"               best="event coverage, premium features"><Opt16 /></Option>
          <Option num={17} label="App Banner Style"          best="mobile-first or mobile-heavy sites"><Opt17 /></Option>
          <Option num={18} label="Glassmorphism Card"        best="visually rich, magazine-style sites"><Opt18 /></Option>
          <Option num={19} label="Bold Editorial Price"      best="minimalist sites, serif publications"><Opt19 /></Option>
          <Option num={20} label="Branded Unlock Strip"      best="full-width paywall bar, any site"><Opt20 /></Option>
        </div>
      </div>
    </div>
  );
}
